import React from 'react';

const Error404Page = () => <h1>Error 404</h1>;

export default Error404Page;